import axios from "axios";
 
// const base_path = getBaseUrl();
const base_path = window.APP_CONFIG?.BASE_URL;


export const getAllOrderList = async (userId) => {
 
    const response = await axios.get(`${base_path}/api/Orders/GetAll?UserGuId=${userId}`);
   
    return response.data;
  };

  export const order = async (orderData) => {
  
      const response = await axios.post(`${base_path}/api/Orders/Save`,orderData);
     
      return response.data;
    };
    export const singleOrder = async (orderId) => {
  
      const response = await axios.get(`${base_path}/api/Orders/GetbyGuId?guid=${orderId}`);
     
      return response.data;
    };